export default __webpack_public_path__ + "static/media/onboarding_snap_save_1.404210fa.png";